module.exports = __webpack_public_path__ + "static/media/pre-dorset_text_02.795172f2.jpg";